/**
 * Initialize carrier composable
 * Validate FF and user role
 * If user has insufficient credentials redirect to 403 page
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const { isCarrierProfileEnabled } = await useIsCarrierProfileEnabled();
  const { addRumError } = useAcvDatadog();
  if (!isCarrierProfileEnabled.value) {
    addRumError('403 error from checkCarrierProfileByRole');

    return navigateTo('/403');
  }

  /**
   * Set "Your Profile" as the default page
   */
  if (to.fullPath === '/carrier-profile' || to.fullPath === '/carrier-profile/') {
    return navigateTo({
      path: '/carrier-profile/your-profile',
    });
  }
});
